module.exports = "<p>\r\n  regular-approved-attendance works!\r\n</p>\r\n"